import React from 'react';

const statusColors: Record<string, string> = {
  NEW: 'bg-blue-100 text-blue-800',
  IN_REVIEW: 'bg-amber-100 text-amber-900',
  PARTIALLY_RESOLVED: 'bg-orange-100 text-orange-900',
  RESOLVED: 'bg-green-100 text-green-800',
  DENIED: 'bg-red-100 text-red-800',
  ARCHIVED: 'bg-slate-200 text-slate-700',
  SUBMITTED: 'bg-sky-100 text-sky-800',
  APPROVED: 'bg-teal-100 text-teal-800',
  LABEL_READY: 'bg-violet-100 text-violet-800',
  AWAITING_DROPOFF: 'bg-yellow-100 text-yellow-900',
  IN_TRANSIT: 'bg-indigo-100 text-indigo-800',
  DELIVERED_PENDING_REVIEW: 'bg-purple-100 text-purple-800',
  RECEIVED: 'bg-emerald-100 text-emerald-800',
  EXPIRED: 'bg-rose-100 text-rose-800',
};

export const RequestStatusBadge = ({
  status,
  label,
}: {
  status: string;
  label: string;
}) => (
  <span
    className={`inline-block rounded px-2 py-1 text-xs font-medium ${
      statusColors[status] || 'bg-gray-100 text-gray-800'
    }`}
  >
    {label}
  </span>
);
